import type { ProductDetailsProductData } from "@jti/fe-common";

type TierPrice = ProductDetailsProductData["tierPrices"][number];

export type ValidTierPrice = TierPrice & {
  quantity: number;
  label: string;
  discount: {
    percentOff: number;
  };
  finalPrice: {
    value: number;
    currency: string;
  };
  totalPrice: {
    value: number;
    currency: string;
  };
};

const isValidTierPrice = (tierPrice: TierPrice): tierPrice is ValidTierPrice => {
  return (
    Number.isInteger(tierPrice.quantity) &&
    tierPrice.quantity > 0 &&
    Boolean(tierPrice.label) &&
    Number.isFinite(tierPrice.discount?.percentOff) &&
    Number.isFinite(tierPrice.finalPrice?.value) &&
    Boolean(tierPrice.finalPrice?.currency) &&
    Number.isFinite(tierPrice.totalPrice?.value) &&
    Boolean(tierPrice.totalPrice?.currency)
  );
};

export const getValidTierPrices = (tierPrices: ProductDetailsProductData["tierPrices"]): ValidTierPrice[] => {
  return tierPrices.filter(isValidTierPrice);
};
